import '../../index.css';
import React, { Component } from 'react';
import firebase from '../../helpers/firebase';
import { Helmet } from 'react-helmet';

export default class Calendar extends Component {
  static defaultProps = {
    campus: '',
    diningHall: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      calendarId: '',
    };
  }

  componentDidMount() {
    this.fetchCalendarId();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.campus !== prevProps.campus ||
      this.props.diningHall !== prevProps.diningHall
    ) {
      this.fetchCalendarId();
    }
  }

  fetchCalendarId = async () => {
    if (!this.props.campus) {
      return;
    }
    const doc = await firebase
      .firestore()
      .collection('campus')
      .doc(this.props.campus)
      .collection('halls')
      .doc(this.props.diningHall)
      .get();
    this.setState({ calendarId: doc.data()['calendarId'] });
  };

  render() {
    return (
      <div style={{ padding: '32px', flex: 1, display: 'flex' }}>
        <Helmet>
          <meta
            name="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />

          <meta
            itemProp="name"
            content="DeWaste | Food Waste Analysis for all dining institutions"
          />
          <meta
            itemProp="description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta itemProp="image" content="https://de-waste.com/logo.png" />

          <meta property="og:image" content="https://de-waste.com/logo.png" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="DeWaste" />
          <meta
            property="og:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
          <meta property="og:site_name" content="DeWaste" />
          <meta property="og:url" content="https://de-waste.com" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:image" content="https://de-waste.com/logo.png" />
          <meta name="twitter:title" content="DeWaste" />
          <meta
            name="twitter:description"
            content="DeWaste is the easiest way to quickly and reliably reduce food waste. Using image analysis, we can give you accurate wastage data instantly."
          />
        </Helmet>

        {this.state.calendarId ? (
          <iframe
            src={
              'https://calendar.google.com/calendar/embed?src=' +
              this.state.calendarId +
              '&ctz=America%2FLos_Angeles'
            }
            style={{
              display: 'inline-block',
              border: 0,
              flex: 1,
            }}
            title={'Calendar'}
          />
        ) : (
          <div style={{ padding: '16px' }}>Loading...</div>
        )}
      </div>
    );
  }
}
